var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tokens-demand-list',{attrs:{"value":_vm.demandList,"loading":_vm.loadingData,"search":_vm.search,"cancellable":function (item) { return item.status === 'inProgress'; }},on:{"cancel":_vm.cancelDemand}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }